type GetTourCalendarUrlParams = {
  listingAlias: string;
  tourId?: string;
};

export default function getTourCalendarUrl({ listingAlias, tourId }: GetTourCalendarUrlParams): string {
  const url = `/rental-manager/properties/${encodeURIComponent(listingAlias)}/tours/tour-calendar`;
  return tourId ? `${url}?tourId=${encodeURIComponent(tourId)}` : url;
}
